import { useState } from "react";
import { LuX } from "react-icons/lu";
import { Link } from "react-router-dom";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

// Toggle this flag to enable/disable the announcement banner
const BANNER_ENABLED = true;

const BANNER_DISMISSED_KEY = "announcement_banner_dismissed_jan_2026";

export function WelcomeAnnouncementBanner() {
  const isCompactView = useIsCompactView();
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem(BANNER_DISMISSED_KEY) === "true";
  });

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    setIsDismissed(true);
  };

  if (!BANNER_ENABLED || isDismissed) {
    return null;
  }

  return (
    <div className="w-full bg-primary-blue/90 text-white py-2 px-4 flex items-center justify-center gap-3 relative z-20">
      <Link
        to="/app-store-rankings"
        className={`flex items-center gap-2 hover:underline ${isCompactView ? "pr-10" : ""}`}
      >
        <span className="px-2 py-0.5 text-sm font-semibold rounded-full bg-white text-primary-blue">
          New
        </span>
        <span className="text-sm">
          {isCompactView
            ? "Discover Apps: Browse Rankings & Build"
            : "Discover Apps: Browse Real App Store Rankings & Build Inspired"}
        </span>
      </Link>
      <button
        onClick={handleDismiss}
        className="absolute right-4 p-1 hover:bg-white/20 rounded transition-colors"
        aria-label="Dismiss announcement"
      >
        <LuX size={16} />
      </button>
    </div>
  );
}
